import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  ExportPurchasePayload,
  PurchaseItemType,
  UpdatePurchaseStatePayload,
} from './types'

export class PurchaseService {
  static getPurchases(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PurchaseItemType[]>> {
    return apiService.get('/purchase/demands', config)
  }

  static updatePurchaseState(
    data: UpdatePurchaseStatePayload,
  ): Promise<AxiosResponse> {
    return apiService.put('/purchase', data)
  }

  static exportPurchase(
    data: ExportPurchasePayload,
  ): Promise<AxiosResponse<Blob>> {
    return apiService.postBlob('/purchase/export', data)
  }

  static deletePurchaseDemand(id: string): Promise<AxiosResponse> {
    return apiService.delete(`/purchase/demands/${id}`)
  }
}
